import ConfiguratorSelect from './configurator-select';

class ConfiguratorNavigation {
    constructor() {
        this.configurator = jQuery('.js-configurator');
        this.navigationSelect = new ConfiguratorSelect('#navigation-select');

    }

    _changeStep(stepIndex) {
        if (stepIndex) {
            this.currentStep = stepIndex;
            this.configurator.attr('data-configurator-step', stepIndex);
            this.navigationSelect.select.find(`option[value="${stepIndex}"]`).attr("selected",true).siblings().attr("selected",false);
            const label = this.navigationSelect.select.find('option[selected]').text();
            this.navigationSelect.select.next('.select2').find('.select2-selection__rendered').text(label);
        }
    }

    _setNextButtonText(stepIndex) {
        const link = this.footerNavigationItems.eq(stepIndex);
        if (link.length) {
            this.navNext.text(link.text());
        }
    }

    _getPrevious() {
        const step = this.footerNavigationItems.filter(`[data-step=${this.currentStep}]`).prev().data('step');
        return step ? step : 1
    }

    _getNext() {
        const step = this.footerNavigationItems.filter(`[data-step=${this.currentStep}]`).next().data('step');
        return step < this.stepsNumber ? step : this.stepsNumber;
    }

    events() {
        this.navLink.on('click', (e) => {
            e.preventDefault();
            const stepIndex = jQuery(e.target).data('step');
            this._changeStep(stepIndex);
        });
        this.navBack.on('click', (e) => {
            e.preventDefault();
            const stepIndex = this._getPrevious();
            this._changeStep(stepIndex);
        });
        this.navNext.on('click', (e) => {
            e.preventDefault();
            const self = jQuery(e.target);
            const stepIndex = this._getNext();
            this._changeStep(stepIndex);
        });
        this.navStart.on('click', (e) => {
            e.preventDefault();
            this._changeStep(this.initStep);
        });

        // this.navNextMobile.on('click', (e) => {
        //     e.preventDefault();
        //     const self = jQuery(e.target);
        //     const stepIndex = this._getNext();
        //     this._changeStep(stepIndex);
        // });

        this.navigationSelect.onChange((select) => {
            this._changeStep(select.val());
        });
    }

    init() {
        if (this.configurator && this.navigationSelect) {
            try {
                this.footerNavigationItems = this.configurator.find('.js-configurator-nav li');
                this.stepsNumber = this.configurator.data('configurator-max-step');
                this.navLink = this.configurator.find('.js-configurator-nav-link');
                this.navBack = this.configurator.find('.js-configurator-nav-back');
                this.navNext = this.configurator.find('.js-configurator-nav-next');
                this.navStart = this.configurator.find('.js-configurator-nav-start');
                this.currentStep = this.initStep = this.footerNavigationItems.first().data('step');
                this._changeStep(this.currentStep);
                this.events();
            } catch (e) {

            }
        }
    }
}

export default ConfiguratorNavigation;
